module.exports = __webpack_public_path__ + "img/illustration-empty.b5ea7699.svg";